import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProof() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 0.7
  }} className="mt-8 md:mt-14 max-w-md mx-auto" data-id="element-110">
      <div className="flex items-center justify-center gap-1 mb-2" data-id="element-111">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 fill-gold text-gold" data-id="element-112" />)}
        <span className="text-white font-bold ml-2 text-sm md:text-base" data-id="element-113">
          4.9/5
        </span>
      </div>

      <p className="font-bold text-white text-base md:text-lg mb-0.5" data-id="element-114">
        Elegido por abogados en toda Argentina
      </p>
      <p className="text-gray-400 text-xs md:text-sm mb-5 md:mb-8" data-id="element-115">
        El sistema de gestión para estudios jurídicos más completo y profesional
        del mercado
      </p>

      <div className="grid grid-cols-2 gap-2 md:gap-4" data-id="element-116">
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-117">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-118">+800</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-119">
            Profesionales confían en el sistema
          </p>
        </div>
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-120">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-121">4.9/5</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-122">
            Valoración promedio
          </p>
        </div>
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-123">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-124">+180</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-125">
            Recursos legales y plantillas
          </p>
        </div>
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-126">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-127">#1</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-128">
            Sistema elegido en Argentina
          </p>
        </div>
      </div>
    </motion.div>;
}